import { ChangeDetectorRef, Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';

import { VideoRecordingService } from './screen-recorder.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SnackbarService } from '../services/snackbar.service';
import { UserAuthenticationServices } from '../services/user-authentication.services';
import { PermissionServices } from '../services/permission.services';
import { DialogService } from '../services/dialog.service';
import { PromptFilterViewComponent } from '../forms/prompt-filter-view/prompt-filter-view.component';
import { GenericEdit } from '../interfaces/generic-edit';
import { NgxSpinnerService } from 'ngx-spinner';
import { ThemeService } from '../services/theme.service';
import { LanguageServices } from '../services/LanguageServices';
import { NzMessageService } from 'ng-zorro-antd/message';


type RecordingState = 'NONE' | 'RECORDING' | 'RECORDED';

@Component({
    selector: 'screen-recorder',
    templateUrl: './screen-recorder.component.html',
    styleUrls: ['./screen-recorder.component.scss'],
    standalone: false
})
export class ScreenRecorderComponent implements OnInit {

  isOver = false;
  openMenu = false;
  @ViewChild('videoElement') videoElement: any;
  title = 'record-rtc-screen-demo';
  //videoBlobUrl: any = null;
  videoBlobUrlSrc: any = '';
  video: any;
  state: RecordingState = 'NONE';
  canInsert: boolean = false;
  data:GenericEdit;
  showFloatButton: boolean =true;
  showProgressBar:boolean = false;
  @Output() saving:EventEmitter<{changing:boolean, keepOpen:boolean}> = new EventEmitter();


  constructor(
    private videoRecordingService: VideoRecordingService,
    private ref: ChangeDetectorRef,
    private dialogServices:DialogService,
    private sanitizer: DomSanitizer,
    private message:NzMessageService,
    private ap:PermissionServices,
    private spinner:NgxSpinnerService,
    public ThemeService:ThemeService,
    public ls:LanguageServices,
  ) {
    this.canInsert = ap.checkPermission('Mktpmedia').canInsert;
    this.videoRecordingService.getMediaStream().subscribe((data) => {
      this.video.srcObject = data;
      this.ref.detectChanges();
    });
    this.videoRecordingService.getBlob().subscribe((data) => {
      this.videoBlobUrlSrc = this.sanitizer.bypassSecurityTrustUrl(data);
      this.video.srcObject = null;
      this.ref.detectChanges();
    });
  }
  ngOnInit(): void {
    if (this.data!= null ){
        
        if ( this.data.evento=='inserindo'){
          return;
        }
            
        this.showFloatButton = false;
        this.title = this.data.row['NAME'];
        this.spinner.show('media-loading');
        this.videoRecordingService.loadData(this.data).then((url:string)=>{
            this.state='RECORDED';
            //this.videoBlobUrl = null; //this.sanitizer.bypassSecurityTrustUrl(url);;
            this.video.srcObject = null;
            this.videoBlobUrlSrc = this.sanitizer.bypassSecurityTrustUrl(url)
            this.ref.detectChanges();
        }).finally(()=>this.spinner.hide('media-loading'));
    }
  }

  ngAfterViewInit(): void {
    if ( this.data!=null && this.data.evento=='inserindo'){
      this.message.error(this.ls.instant('insert_not_allowed'));
      setTimeout(()=>{
        this.saving.next({changing:false,keepOpen:false});
      })
    }else{
      if ( this.videoElement!= null){
        this.video = this.videoElement.nativeElement;
      }
    }
    
  }

  onFileActionChange(event:any){
    if ( event == 'save' ){
      this.saveRecording();
    }
    if ( event == 'download' ){
      this.downloadRecording();
    }
    if ( event == 'clear' ){
      this.clearRecording();
    }
  }

  onRecordActionChange(event:any){
    if ( event == 'record' ){
      this.startRecording();
    }else{
      this.stopRecording();
    }
  }

  startRecording() {
    this.videoRecordingService.startRecording();
    this.state = 'RECORDING';
    
  }

  stopRecording() {
    this.videoRecordingService.stopRecording();
    this.state = 'RECORDED';
  }

  downloadRecording() {
    this.videoRecordingService.downloadRecording();
  }

  saveRecording(){

    let data= {
    data: JSON.stringify([
      {
        desc:this.ls.instant('video_name'),
        nome: 'NAME',
        tipo:'S',
      },
      { 
        desc:this.ls.instant('contract'),
        nome: 'CODECONTRACT',
        tipo:'R',
        apresentationField:'CONTRACTNAME',
        controlName:'CODECONTRACT',
        entityDesc:'Contrato',
        entityName:'Mktpcontract'
      },
      {
        desc:this.ls.instant('company'),
        nome: 'CODECOMPANY',
        tipo:'R',
        apresentationField:'NAME',
        controlName:'CODECOMPANY',
        entityDesc:'Empresa',
        entityName:'Mktpcompanies'
      },
      {
        desc:this.ls.instant('channel'),
        nome: 'CODEMKTP',
        tipo:'R',
        apresentationField:'NAME',
        controlName:'CODEMKTP',
        entityDesc:'Canais',
        entityName:'Mktplaces'
      }
    ]),
    title: this.ls.instant('inform_data'),
    useParamFilter:true}
    this.showProgressBar = true;
    this.dialogServices.openGenericDialog(PromptFilterViewComponent,data,
    (val)=>{
      let group = JSON.parse(val)['group']
      let codeContract = group['CODECONTRACT'];  
      let codeCompany = group['CODECOMPANY'];
      let codeMktp = group['CODEMKTP'];
      let name = group['NAME'];
      this.videoRecordingService.saveVideo(codeContract,codeCompany,codeMktp,name).then(d=>{
          this.downloadRecording();
          this.message.success(this.ls.instant('recording_saved'));
          this.state = 'NONE';
      }).catch(error=>{
          throw error;
      });
    }
      
    )
  }

  clearRecording() {
    this.videoRecordingService.clearRecording();
    this.video.srcObject = null;
    //this.videoBlobUrl = null;
    this.state = 'NONE';
    this.saving.next({changing:false,keepOpen:false});
  }

  clickMenu(){
    this.openMenu = !this.openMenu;
  }

  @HostListener('window:keydown.control.alt.g', ['$event'])
  public onKeyUpStart(event: KeyboardEvent): void {    
      event.preventDefault();
      if ( this.state == 'RECORDED' || this.state=='NONE'){
        this.startRecording();
        this.message.success(this.ls.instant('recording_started'));
      }
  }

  @HostListener('window:keydown.control.alt.s', ['$event'])
  public onKeyUpStop(event: KeyboardEvent): void {    
      event.preventDefault();
      if ( this.state == 'RECORDING' ){
        this.stopRecording();
        this.message.success(this.ls.instant('recording_finished'));
      }
  }

  
}
